import React, { FC } from "react";
import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { ContactInfo } from "../View/Contact/ContactInfo";
import { GoBack } from "../View/GoBack";
import { FormContainer } from "../View/Contact/FormContainer";
import { ContactFormParams } from "../../../Pages/ContactForm/ContactFormParams.csharp";

export const ContactPage: FC<ContactFormParams> = (props) => {
  const { isAuthenticated, locations } = props;

  const { buttons, tabHeadings } = useInsuranceLabels();

  return (
    <div className="insuranceBody insurancePageWithForm">
      <div className="insurancePageWithForm__controls">
        <GoBack label={buttons.goToListViewButtonLabel} />
      </div>
      <div className="insurancePageWithForm__info">
        <ContactInfo
          header={tabHeadings.contactUsTabHeading}
          locations={locations}
        />
      </div>
      <div className="insurancePageWithForm__form">
        <FormContainer isAuthenticated={isAuthenticated} />
      </div>
    </div>
  );
};
